/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/Actions/CancelAction",
  isSubmitting
  
}) {
let questionIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'question',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnCancelClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginRight={dtSpaceXs}
 type="secondary"
 paddingTop={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 paddingRight={dtSpaceXs}
 onClick={onClick}
 data="question"
 disabled={questionIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}